import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { PerfectScrollbarConfigInterface, PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { AppComponent } from './app.component';
// Import containers
import { DefaultLayoutComponent } from './containers';

import { P404Component } from './pages/error/404.component';
import { P500Component } from './pages/error/500.component';
import { LoginComponent } from './pages/login/login.component';
import { AppAsideModule, AppBreadcrumbModule, AppFooterModule, AppHeaderModule, AppSidebarModule, } from '@coreui/angular';
// Import routing module
import { AppRoutingModule } from './app.routing';
// Import 3rd party components
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LandingPageComponent } from './pages/landing-page/landing-page.component';
import { NavigationBarComponent } from './navigation-bar/navigation-bar.component';
import { AuthenticationInterceptor } from './_services/auth/auth.interceptor';
import { NgbDropdownModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { OpdListComponent } from './pages/general/opd-list/opd-list.component';
import { SekolahListComponent } from './pages/general/sekolah-list/sekolah-list.component';
import { SekolahListKonfirmasiComponent } from './pages/general/sekolah-list-konfirmasi/sekolah-list-konfirmasi.component';
import { SekolahListBopComponent } from './pages/general/sekolah-list-bop/sekolah-list-bop.component';
import { DataTablesModule } from 'angular-datatables';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DetailComponent } from './page/bos-negeri/bos-cetak-setor/bos-cetak-setor/detail/detail.component';
import { BosCetakSetorDetailComponent } from './page/bos-negeri/bos-cetak-setor/bos-cetak-setor-detail/bos-cetak-setor-detail.component';
import { LoaderComponent } from './shared/loader/loader.component';
import { SekolahListBatasPengajuanComponent } from './pages/general/sekolah-list-batas-pengajuan/sekolah-list-batas-pengajuan.component';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

const APP_CONTAINERS = [
  DefaultLayoutComponent
];

@NgModule({
  imports: [
    NgbModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AppAsideModule,
    AppBreadcrumbModule.forRoot(),
    AppFooterModule,
    AppHeaderModule,
    AppSidebarModule,
    PerfectScrollbarModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ReactiveFormsModule,
    HttpClientModule,
    NgbDropdownModule,
    DataTablesModule,
    NgxSpinnerModule,
    NgbModule,
  ],
  declarations: [
    AppComponent,
    ...APP_CONTAINERS,
    P404Component,
    P500Component,
    LoginComponent,
    LandingPageComponent,
    NavigationBarComponent,
    OpdListComponent,
    SekolahListComponent,
    SekolahListKonfirmasiComponent,
    SekolahListBatasPengajuanComponent,
    DetailComponent,
    BosCetakSetorDetailComponent,
    SekolahListBopComponent,
    LoaderComponent,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      multi: true,
      useClass: AuthenticationInterceptor
    },
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
